var React = require('react');

function Spinner (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n    .line {\n      transform: rotate(0);\n      transform-origin: 50%;\n      fill:none;stroke:var(--text-primary);stroke-width:18;\n    }\n    .faded {\n      opacity: 0.1;\n    }\n    .spin {\n      stroke-dasharray: 315;\n        stroke-dashoffset: 80;\n      animation: spin 1s linear forwards infinite;\n    }\n    @keyframes spin {\n      from {\n        transform: rotate(0deg);\n      }\n      to {\n        transform: rotate(360deg);\n      }\n    }\n  "),React.createElement("circle",{"className":"line faded","cx":"64","cy":"64","r":"50","key":1}),React.createElement("path",{"className":"line spin","d":"M114,64c0,27.61423-22.38577,50-50,50 S14,91.61423,14,64s22.38576-50,50-50S114,36.38576,114,64","key":2})]);
}

Spinner.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 128 128"};

module.exports = Spinner;

Spinner.default = Spinner;
